import { LoaderFunction } from "react-router-dom";
import { axiosApi } from "../../interceptors/axios";
import { Result } from "../../types/Result";
import { Exam } from "./type";

export const examLoader: LoaderFunction = async (args) => {
  if (args.params.examId === "new") {
    return new Promise((res) => res(Result.newResult()));
  }
  var parts = args.params.examId?.split("_") || [];
  const result = await axiosApi.get<Result<Exam[]>>(
    "/api/exams/" + parts.join("/")
  );
  return result.data;
};
